import { PHONE, locationSchema } from "../structured-data-core";

export function getTampaStructuredData() {
  const url = "https://restorehair.com/locations/florida/tampa/";
  const description =
    "Find out about your hair transplant options in Tampa with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Tampa", "8875 Hidden River Pkwy, Suite 300", "Tampa", "FL", PHONE, url, description),
  ];
}
